<div class="simple-doughnut-chart pt-1">
    <div class="donut">
        <svg height=30px width=30px viewBox="0 0 100 100" xml:space="preserve" alt="">
            <circle cx="50" cy="50" r="42" class="circle-back" />
            <circle cx="50" cy="50" r="42" class="circle-front" 
            [style]='doughnutstyle'/>
        </svg>
    </div>
</div>